import React, {useState} from "react";
import {css} from "@emotion/react";

import {calculateRemSize} from "@pg-design/helpers-css";
import {countDistance} from "@pg-mono/geo-utils";
import {convertToLatLngLiteralOfPoland} from "@pg-mono/open-street-map";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {TravelModeButton} from "../../../../maps/components/TravelModeButton";
import {IUserPoi} from "../../../../maps/types/IUserPoi";
import {PoiType} from "../../../../maps/utils/PoiType";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {TravelMode} from "../../../../property/utils/TravelMode";
import {useCalculateTravelTime} from "../../../hooks/use_calculate_travel_time";

export const DistanceFromCenterCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;

    const calculateTravelTime = useCalculateTravelTime();
    const [drivingDuration, setDrivingDuration] = useState<string | null>(null);
    const [walkingDuration, setWalkingDuration] = useState<string | null>(null);
    const [transitDuration, setTransitDuration] = useState<string | null>(null);

    const propertyDetails = property;

    if (!propertyDetails.offer.stats || !propertyDetails.offer.stats.distance_from_region.center) {
        return <div>-</div>;
    }

    const getTravelDuration = async (travelMode: TravelMode) => {
        if (!propertyDetails.offer.stats || !propertyDetails.offer.stats.distance_from_region.center) {
            return "-";
        }

        const poiLocation = convertToLatLngLiteralOfPoland(propertyDetails.offer.stats.distance_from_region.coords);
        const targetLocation = convertToLatLngLiteralOfPoland(propertyDetails.offer.geo_point.coordinates);

        const centerPoi: IUserPoi = {
            id: Date.now(),
            name: "Centrum",
            distance: countDistance(poiLocation, targetLocation),
            lat: poiLocation.lat,
            lng: poiLocation.lng,
            tags: {address: propertyDetails.offer.stats.distance_from_region.region}
        };

        return await calculateTravelTime(centerPoi, PoiType.USER, propertyDetails.offer.geo_point.coordinates, travelMode);
    };

    return (
        <div css={travelModeStyle}>
            <TravelModeButton
                css={travelModeButtonStyle}
                travelMode={TravelMode.TRANSIT}
                duration={transitDuration}
                selected={Boolean(transitDuration)}
                onClick={async () => {
                    if (!transitDuration) {
                        const travelDuration = await getTravelDuration(TravelMode.TRANSIT);
                        setTransitDuration(travelDuration);
                    }
                }}
            />
            <TravelModeButton
                css={travelModeButtonStyle}
                travelMode={TravelMode.WALKING}
                duration={walkingDuration}
                selected={Boolean(walkingDuration)}
                onClick={async () => {
                    if (!walkingDuration) {
                        const travelDuration = await getTravelDuration(TravelMode.WALKING);
                        setWalkingDuration(travelDuration);
                    }
                }}
            />
            <TravelModeButton
                css={travelModeButtonStyle}
                travelMode={TravelMode.DRIVING}
                duration={drivingDuration}
                selected={Boolean(drivingDuration)}
                onClick={async () => {
                    if (!drivingDuration) {
                        const travelDuration = await getTravelDuration(TravelMode.DRIVING);
                        setDrivingDuration(travelDuration);
                    }
                }}
            />
        </div>
    );
};

const travelModeStyle = css`
    display: flex;
    flex-direction: column;
    width: ${calculateRemSize(11)};
    row-gap: ${calculateRemSize(0.5)};
`;

const travelModeButtonStyle = css`
    margin: 0;
`;
import React, {useState} from "react";
import {css} from "@emotion/react";

import {calculateRemSize} from "@pg-design/helpers-css";
import {countDistance} from "@pg-mono/geo-utils";
import {convertToLatLngLiteralOfPoland} from "@pg-mono/open-street-map";
import {IComparisonTableCell} from "@pg-rp/comparison-table";

import {TravelModeButton} from "../../../../maps/components/TravelModeButton";
import {IUserPoi} from "../../../../maps/types/IUserPoi";
import {PoiType} from "../../../../maps/utils/PoiType";
import {IPropertyDetail} from "../../../../property/types/IPropertyDetail";
import {TravelMode} from "../../../../property/utils/TravelMode";
import {useCalculateTravelTime} from "../../../hooks/use_calculate_travel_time";

export const DistanceFromCenterCell: IComparisonTableCell<IPropertyDetail> = (props) => {
    const property = props.item;

    const calculateTravelTime = useCalculateTravelTime();
    const [drivingDuration, setDrivingDuration] = useState<string | null>(null);
    const [walkingDuration, setWalkingDuration] = useState<string | null>(null);
    const [transitDuration, setTransitDuration] = useState<string | null>(null);

    const propertyDetails = property;

    if (!propertyDetails.offer.stats || !propertyDetails.offer.stats.distance_from_region.center) {
        return <div>-</div>;
    }

    const getTravelDuration = async (travelMode: TravelMode) => {
        if (!propertyDetails.offer.stats || !propertyDetails.offer.stats.distance_from_region.center) {
            return "-";
        }

        const poiLocation = convertToLatLngLiteralOfPoland(propertyDetails.offer.stats.distance_from_region.coords);
        const targetLocation = convertToLatLngLiteralOfPoland(propertyDetails.offer.geo_point.coordinates);

        const centerPoi: IUserPoi = {
            id: Date.now(),
            name: "Centrum",
            distance: countDistance(poiLocation, targetLocation),
            lat: poiLocation.lat,
            lng: poiLocation.lng,
            tags: {address: propertyDetails.offer.stats.distance_from_region.region}
        };

        return await calculateTravelTime(centerPoi, PoiType.USER, propertyDetails.offer.geo_point.coordinates, travelMode);
    };

    return (
        <div css={travelModeStyle}>
            <TravelModeButton
                css={travelModeButtonStyle}
                travelMode={TravelMode.TRANSIT}
                duration={transitDuration}
                selected={Boolean(transitDuration)}
                onClick={async () => {
                    if (!transitDuration) {
                        const travelDuration = await getTravelDuration(TravelMode.TRANSIT);
                        setTransitDuration(travelDuration);
                    }
                }}
            />
            <TravelModeButton
                css={travelModeButtonStyle}
                travelMode={TravelMode.WALKING}
                duration={walkingDuration}
                selected={Boolean(walkingDuration)}
                onClick={async () => {
                    if (!walkingDuration) {
                        const travelDuration = await getTravelDuration(TravelMode.WALKING);
                        setWalkingDuration(travelDuration);
                    }
                }}
            />
            <TravelModeButton
                css={travelModeButtonStyle}
                travelMode={TravelMode.DRIVING}
                duration={drivingDuration}
                selected={Boolean(drivingDuration)}
                onClick={async () => {
                    if (!drivingDuration) {
                        const travelDuration = await getTravelDuration(TravelMode.DRIVING);
                        setDrivingDuration(travelDuration);
                    }
                }}
            />
        </div>
    );
};

const travelModeStyle = css`
    display: flex;
    flex-direction: column;
    width: ${calculateRemSize(11)};
    row-gap: ${calculateRemSize(0.5)};
`;

const travelModeButtonStyle = css`
    margin: 0;
`;
